(ns hypnos.dme.app
  "The DME application."
  (:require ["aws-amplify-react" :refer (
                                         ConfirmSignIn
                                         ;; ConfirmSignUp
                                         ForgotPassword
                                         RequireNewPassword
                                         SignIn
                                         ;; SignUp
                                         VerifyContact
                                         withAuthenticator)]
            [hypnos.dme.bar.aside :as aside]
            [hypnos.dme.bar.footer :as footer]
            [hypnos.dme.bar.navigation :as nav]
            [hypnos.dme.bar.title :as title]
            [hypnos.dme.panel.dashboard :as dashboard]
            [hypnos.dme.panel.error :as error]
            [hypnos.dme.panel.patient :as patient]
            [hypnos.dme.panel.patients :as patients]
            [hypnos.dme.panel.referral :as referral]
            [hypnos.graphql.queries :as queries]
            [re-frame.core :as rf]
            [reagent.core :as reagent]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; Helpers

(defn- panels
  [panel]
  (case (:name panel)
    ;; external
    :dashboard-panel [dashboard/panel]
    :patient-panel   [patient/panel (:params panel)]
    :patients-panel  [patients/panel]
    :referral-panel  [referral/panel (:params panel)]
    [:div]))

(defn- container
  []
  (let [_ (rf/dispatch-sync [:amplify/get-auth-session :dme/set-session :dme/set-error])
        _ (rf/dispatch-sync [:amplify/query queries/get-user {} :dme/set-user :dme/set-error])
        _ (rf/dispatch [:amplify/query queries/get-catalog {} :dme/set-catalog :dme/set-error])]
    (fn []
      (let [active-panel (rf/subscribe [:dme/active-panel])]
        [:div
         [nav/bar]
         [aside/primary]
         [aside/secondary]
         [title/bar]
         [error/panel]
         [panels @active-panel]
         [footer/bar]]))))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; API

(def app
  (reagent/adapt-react-class
   (withAuthenticator
    (reagent/reactify-component container)
    false
    #js [(reagent/create-element SignIn)
         (reagent/create-element ConfirmSignIn)
         (reagent/create-element VerifyContact)
         (reagent/create-element RequireNewPassword)
         (reagent/create-element ForgotPassword)])))
